export default __webpack_public_path__ + "static/media/course-content-completed-pic.eed41c4e.svg";